function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 203 203",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero"
    },
    d: "m102 0c28 0 53 11 71 30 19 18 30 44 30 72s-11 53-30 71c-18 19-43 30-71 30s-54-11-72-30c-19-18-30-43-30-71s11-54 30-72c18-19 44-30 72-30zm65 169h-1c0-1-1-2-2-2-8-8-18-14-25-18-8-5-13-7-15-8-1-1-2-1-2-2-1-1-1-2-1-3v-15-1c1-1 2-3 3-4 0-2 1-4 1-5v-3l3-1c1 0 0 0 0 0 1-1 2-3 3-7 1-3 1-5 1-7h-5c1-2 1-4 2-7 4-23-6-23-6-23l-2-1-1-1s-1-4-6-6l-6-3c-3 0-5-1-8 0h-1-2c-1 0-2 0-3 1-1 0-2 1-3 1-2 1-3 1-4 2l-6 6c-2 1-3 3-5 5-1 2-2 4-3 7v6c0 2 0 4 1 6l1 7h-4v1c0 2 0 4 1 6 1 4 2 6 3 7h-1l3 1 1 3c0 1 0 3 1 4 1 2 1 4 2 5l1 1v15c0 1-1 2-1 3l-2 2c-2 0-8 3-15 8-8 4-17 10-26 18l-2 2c1 1 2 1 2 2 17 15 39 24 64 24 24 0 47-9 64-25l1-1zm-136-6c1-1 1-2 2-2 10-8 19-14 27-19 6-4 11-6 14-8v-11c-1-1-2-3-2-5-1-1-1-3-1-4l-3-3c-1-2-2-4-4-9 0-3-1-5-1-7 0-3 1-5 1-6l2-2c-1-2-1-5-1-7 0-3 0-5 1-8s2-6 4-9c1-2 3-5 5-7 1-1 3-2 4-3 1-2 3-3 4-3 1-1 3-2 4-3 1 0 3-1 4-2 2 0 3 0 4-1h4c4 0 7 0 11 1 3 0 5 2 8 3 4 2 7 6 8 7 4 2 14 8 11 32 1 1 1 2 2 3 1 3 1 7-1 12-1 5-2 7-3 9l-3 3c0 1-1 3-1 4-1 2-2 4-2 5v11c2 2 8 5 14 8 8 5 17 11 26 19l3 3c15-17 23-39 23-62 0-26-10-50-27-67s-40-27-66-27-50 10-67 27-27 41-27 67c0 23 8 45 23 61z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.2dc7c7dcfff14215119b0615dd316b53.svg";
export { ForwardRef as ReactComponent };